"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultProps = {
  componentName: "bannerWIthInlineContent",
  elementType: "",
  position: [],
  props: {
    style: {
      backgroundImg: "https://ik.imagekit.io/marketcube/platform/storybook/dd.jpg",
      headingFontSize: "",
      headingColor: "",
      headingAlign: "",
      contentFontSize: "",
      contentColor: "",
      contentPosition: "",
      buttonColor: "",
      buttonBg: "",
      buttonRadius: "5px",
      buttonFontSize: "",
      buttonBorderColor: "",
      buttonHoverColor: "",
      buttonHoverBg: "",
      hoverBorderColor: ""
    },
    body: {
      img: "https://ik.imagekit.io/marketcube/platform/storybook/mc.jpg",
      alt: "alt text",
      title: "Limits Exist Only in the Mind",
      content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.Lorem Ipsum has been the industry's standard dummy text\n        ever since the 1500s, when an unknown printer took a galley Lorem\n        Ipsum is simply dummy text of the printing and typesetting\n        industry.Lorem Ipsum has been the industry's standard dummy text\n        ever since the 1500s, when an unknown printer took a galley\n        ",
      linkTitle: "learn more",
      linkUrl: "/"
    }
  }
};
exports.default = defaultProps;